<template>
    <div id="clientExtraCostForm" class="w-100 text-center">
        <loading v-if="showLoadingClienteExtraCostoForm" />

        <div v-else class="w-100">
            <table class="table table-bordered ">
                <thead>
                    <tr class="bg-secondary">
                        <th nowrap v-for="(header,index) in headers" :key="index"> {{ header }} </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(val,index) in data" :key="index">
                        <td>
                            {{ (index + 1) }}
                        </td>

                        <td>

                            <ui-select
                                class="w-100"
                                has-search
                                placeholder="Seleccionar"
                                searchPlaceholder="Buscar"
                                :options="[]"
                                v-model="val.id_client"
                                :keys="selectFormat"
                                :disabled="true"
                            />
                        </td>
                        <td>
                            <date-picker
                                placeholder="Fecha"
                                type="date"
                                class="w-100"
                                value-type="format"
                                v-model="val.from"
                                :disabled="true"
                            />
                        </td>
                        <td>
                            <date-picker
                                placeholder="Fecha"
                                type="date"
                                class="w-100"
                                value-type="format"
                                v-model="val.to"
                                :disabled="true"
                            />
                        </td>

                        <td>
                            <ui-select
                                class="w-100"
                                has-search
                                placeholder="Seleccionar"
                                searchPlaceholder="Buscar"
                                :options="listCarriers"
                                v-model="val.id_carrier"
                                :keys="selectFormat"
                                :disabled="true"
                            />
                        </td>

                        <td>        
                            <ui-select
                                class="w-100"
                                has-search
                                placeholder = "Seleccionar"
                                searchPlaceholder ="Buscar"
                                :options = "extraCostTypes"
                                v-model="val.id_extra_costos_tipo"
                                :keys="selectFormat"
                                :disabled="true"
                            /> 
                        </td>
                        <td>
                            <ui-select
                                class="w-100"
                                has-search
                                placeholder="Seleccionar"
                                searchPlaceholder="Buscar"
                                :options="containerTypes"
                                v-model="val.id_type_container"
                                :keys="selectFormat"
                                :disabled="true"
                            />
                        </td>

                        <td>
                            <ui-select
                                class="w-100"
                                has-search
                                placeholder="Seleccionar"
                                searchPlaceholder="Buscar"
                                :options="listCurrencies"
                                v-model="val.id_currency"
                                :keys="selectFormat"
                                :disabled="true"
                            />
                        </td>
                        <td>
                            <input 
                                type="text" 
                                class="text_field_mask"
                                v-mask="weightMask"
                                v-model="val.value"
                            />
                        </td>
                        <td>
                            <ui-textbox
                                class="w-100"
                                floating-label
                                placeholder="Observaciones..."
                                v-model="val.comments"
                            />
                        </td>
                    </tr> 
                </tbody>
            </table>

            <Button
                text="Editar"
                :width="120"
                :height="40"
                class="float-right"
                color="#21831b"
                colorText="#fff"
                icon="far fa-paper-plane"
                title="Crear"
                horizontal
                @click.native="!btnAction && update()"
                :inactive="btnAction"

            />

        </div>
        
    </div>
    
</template>

<script >
import DatePicker from "vue2-datepicker";

import createNumberMask from "text-mask-addons/dist/createNumberMask";
import { mapActions, mapState } from 'vuex';
import Button from '../../../common/Button.vue';
import Loading from '../../../common/loading.vue';
import { tariffClientsExtraCostoFind, tariffClientsExtraCostoIndex, tariffClientsExtraCostoUpdate } from "../../../../constants/serviciosLogisticos";

const weightMask = createNumberMask({
  prefix: "",
  suffix: "",
  allowDecimal: true,
  requireDecimal: false,
  includeThousandsSeparator: false,
  decimalSymbol: ".",
  decimalLimit: 2,
  integerLimit: 6
});

export default {

    data() {
        return {
            data : [  ],
            weightMask,
            selectFormat : { value: 'id', label: 'name' },
            headers: [ "N°", "Cliente","Desde", "Hasta", "Proveedor", "Tipo Extra Costo", "Tipo Contenedor", "Moneda", "Valor","Observaciones"],
            btnAction : false,
            showBtnEdit : false ,

        };
    },
    props: {
        closeModal : { type: Function, default: () => {} },
        ids  : { type: Array, default: () => [] },
        idDuplicate : { type: Array, default: () => [] },
    },

    components: { 
        DatePicker , 
        Button, 
        Loading ,
    },

    mounted() {},

    methods: {

        ...mapActions("serviciosLogisticos", [
            "actionSetDataProviderExtraCost",
            "actionSetShowLoadingClienteExtraCosto",
            "actionSetShowLoadingClienteExtraCostoForm",
            "actionSetDataTableClienteExtraCosto"
        ]),

        createPayload(){
            return this.data.map( r => ({
                id              : r.id ?? null ,
                value           : r.value ,
                comment         : r.comments == "" ? null : r.comments ,
            }));
        },

        validate(){

            for ( const index in this.data ) {

                const element = this.data[ index ];

                if( ! element.value ){
                    this.$vToastify.warning("Campo 'Valor' requerido.", "Alerta Item N° " + (index+ 1));
                    return false ;
                }
            }
            return true ;
        } ,

        async update(){

            if( ! this.validate() ) return ;

            this.btnAction = true ;
            const payload = this.createPayload();

            this.$vToastify.loader("Actualizando...");

            try {
                
                await tariffClientsExtraCostoUpdate( payload ) ;

                this.$vToastify.stopLoader();

                this.$vToastify.success("Se han actualizado tarifa cliente correctamente", "Éxito");
                
                this.rechargeTable() ;

                this.btnAction = false ;
                return this.closeModal() ;

            } catch (error) {

                this.$vToastify.stopLoader();
                this.btnAction = false ;

                return this.$vToastify.error("Hubo un error al actualizar, recargue la pagina y vuelva a intentar.", "Error" );
            }
           
        },
        async rechargeTable(){
              
            this.actionSetShowLoadingClienteExtraCosto( true );

            const { data } = await tariffClientsExtraCostoIndex() ;

            this.actionSetDataTableClienteExtraCosto( data ) ;

            this.actionSetShowLoadingClienteExtraCosto( false );

        },
        async setData( ids ){

            this.actionSetShowLoadingClienteExtraCostoForm( true );

            const { data } = await tariffClientsExtraCostoFind({ ids }) ;


            this.data = data.map( d => ({
                id : d.id ,
                id_client : {
                    id: d.id_client ,
                    name : d.name_client
                },
                from : d.from ,
                to : d.to ,
                id_carrier : {
                    id: d.id_carrier ,
                    name : d.name_carrier
                },
                id_extra_costos_tipo : {
                    id: d.id_extra_costos_tipo ,
                    name : d.name_extra_costos_tipos
                },
                id_type_container : {
                    id: d.id_type_container ,
                    name : d.name_type_container
                },
                id_currency : {
                    id: d.id_currency ,
                    name : d.name_format_currency
                },
                value : d.value ,
                comments : d.comment 
            }));

            this.actionSetShowLoadingClienteExtraCostoForm( false );
        }
    },

    computed: {
        ...mapState("serviciosLogisticos", [
                "listCarriers",
                "listCurrencies",
                "extraCostTypes",
                "unityPayments",
                "showLoadingClienteExtraCostoForm",
                "containerTypes"
            ])
    },

     watch : {
            ids : function( _new ){

                if( _new.length > 0 ){
                    this.setData( _new ) ;
                } 
            },
            idDuplicate : function( _new ){
                if( _new.length > 0 ) this.setData( _new , true ) ;
            },
            
    },

    directives: {},

    filters: {}
};
</script>

<style >

#clientExtraCostForm .mx-input {
    padding-left: 2px !important;
    border-radius: 0 !important;
    border: none !important;
    border-bottom: 1px solid #dcdcdc !important;
    box-shadow: none !important;
}

#clientExtraCostForm .text_field_mask {
  background: none;
  border: none;
  border-bottom-color: rgba(0, 0, 0, 0.12);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-radius: 0;
  color: rgba(0, 0, 0, 0.87);
  cursor: auto;
  display: block;
  font-family: inherit;
  font-size: 1rem;
  font-weight: normal;
  margin: 0;
  outline: none;
  padding: 0;
  transition: border 0.1s ease;
  width: 100%;
  height: 32px;
}
</style>